import { webapi } from '@/api/webapi.ts';
import { cancelFixing } from '@/store/orders/fixing/api/cancelFixing.ts';
import { submitFixing } from '@/store/orders/fixing/api/submitFixing.ts';
import { updateFixing } from '@/store/orders/fixing/api/updateFixing.ts';
import { validateFixing } from '@/store/orders/fixing/api/validateFixing.ts';

export const fixingOrderApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    validateFixing: validateFixing(builder),
    submitFixing: submitFixing(builder),
    updateFixing: updateFixing(builder),
    cancelFixing: cancelFixing(builder),
  }),
});

export const { useValidateFixingMutation, useSubmitFixingMutation, useUpdateFixingMutation, useCancelFixingMutation } =
  fixingOrderApi;
